import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
interface PageTurnProps {
  children: ReactNode;
  direction?: 'left' | 'right';
  className?: string;
}
export function PageTurn({
  children,
  direction = 'right',
  className = ''
}: PageTurnProps) {
  const shouldReduceMotion = useReducedMotion();
  if (shouldReduceMotion) {
    return <div className={className} data-id="element-247">{children}</div>;
  }
  const isRight = direction === 'right';
  const spiralRotation = isRight ? -180 : 180;
  return <div className={`${className}`} style={{
    perspective: '1500px'
  }} data-id="element-248">
      <motion.div initial={{
      rotate: spiralRotation,
      scale: 0.3,
      opacity: 0,
      rotateX: 15
    }} whileInView={{
      rotate: 0,
      scale: 1,
      opacity: 1,
      rotateX: 0
    }} viewport={{
      once: true,
      margin: '-60px'
    }} transition={{
      duration: 1.4,
      ease: [0.22, 1, 0.36, 1],
      opacity: {
        duration: 0.6,
        delay: 0.1
      },
      scale: {
        duration: 1.2,
        ease: [0.22, 1, 0.36, 1]
      },
      rotate: {
        duration: 1.4,
        ease: [0.22, 1, 0.36, 1]
      }
    }} style={{
      transformStyle: 'preserve-3d'
    }} className="relative" data-id="element-249">
        {children}
      </motion.div>
    </div>;
}